import {
	FETCH_DRIVER_RECORD_INIT,
 	FETCH_DRIVER_RECORD_SUCCESS,
 	FETCH_DRIVER_RECORD_FAILURE,
  	RESET_DRIVER_RECORD,
  	SET_FILTER_DRIVER_RECORD
 } from './types';
 import API from './api';

/* Actions Creators */

export function setFilterDriverRecord(obj) {
  return {
    type: SET_FILTER_DRIVER_RECORD,
    payload: obj
  };
}

export function resetDriverRecord() {
  return {
    type: RESET_DRIVER_RECORD,
  };
}

 function fetchApiSuccess(data) {
 	return {
 		type: FETCH_DRIVER_RECORD_SUCCESS,
 		payload: data,
 	};
 }

 function fetchApiFailure(error) {
 	console.log(error)
 	return {
 		type: FETCH_DRIVER_RECORD_FAILURE,
 		payload: error,
 	};
 }

 function fetchApiInit() {
 	return {
 		type: FETCH_DRIVER_RECORD_INIT,
 	};
 }

 export function fetchDriverRecordApi(filters) {
 	return async (dispatch) => {
 		dispatch(fetchApiInit());
 		try {
 			let data = await API.data.getAll(filters);
 			dispatch(fetchApiSuccess(data));
 		} catch (error) {
 			dispatch(fetchApiFailure(error));
 		}
 	};
 }



// WEBPACK FOOTER //
// ./source/client/actions/driver_record/index.js